/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Pet Policy bizo
 */

import { capitalize } from '@zcode/nr-utils'
import { dollarize, isNumber } from '@zcode/utils'
import { Bizo, autoclass } from './base'
import type { PetPolicy as PetPolicyType, RawPetPolicy } from './petPolicy.types'

export const PetPolicy = autoclass<PetPolicyType, RawPetPolicy>(
  'PetPolicy',
  class PetPolicy extends Bizo<PetPolicyType, RawPetPolicy> {},
  {
    breedRestrictions: 'breed_restrictions',
    deposit: 'deposit',
    description: 'description',
    fee: 'fee',
    limit: 'limit',
    ok: 'ok',
    rent: 'rent',
    type: 'type',
  } as const
)
export type PetPolicy = PetPolicyType
